import { render, staticRenderFns } from "./Ruffle.vue?vue&type=template&id=4657a542&scoped=true"
import script from "./Ruffle.vue?vue&type=script&lang=js"
export * from "./Ruffle.vue?vue&type=script&lang=js"
import style0 from "./Ruffle.vue?vue&type=style&index=0&id=4657a542&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4657a542",
  null
  
)

export default component.exports